import React from 'react';

function ProjectCard ({settings, className = '', style = {}, children, ...rest}) {
  const settingsMargin = {margin: settings?.margin  || '15px 0 0'}

  return <div {...rest} className={`project-card ${className}`} style={{...style, ...settingsMargin}} >
    {children}
  </div>
}

export default ProjectCard;